import { createContext } from 'react'

const PluginContext = createContext(null)

PluginContext.displayName = 'FunkGoPlugin'

export default PluginContext